import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
import { Seo, seoConfig } from '../components/Seo';
import { getArticleBySlug } from '../data/articles';
export function ArticlePage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const article = getArticleBySlug(slug);
  if (!article) {
    return <Navigate to="/news" replace data-id="element-199" data-mp="dwtnxxf576lt" />;
  }
  const articlePath = `/news/${article.slug}`;
  const articleUrl = `${seoConfig.siteUrl}${articlePath}`;
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-200" data-mp="4zauq5rchlyu">
      <Seo title={article.title} description={article.excerpt} path={articlePath} type="article" image={article.image} schema={{
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      headline: article.title,
      description: article.excerpt,
      datePublished: article.date,
      dateModified: article.date,
      image: [article.image],
      mainEntityOfPage: articleUrl,
      author: {
        '@type': 'Organization',
        name: 'Arizona City Political Action Committee',
        url: seoConfig.siteUrl
      },
      publisher: {
        '@type': 'Organization',
        name: 'AZ City PAC',
        url: seoConfig.siteUrl
      },
      articleSection: article.category,
      keywords: 'Arizona local control, municipal leadership, Arizona cities and towns, zoning, land use, infrastructure, public safety, economic development'
    }} data-id="element-201" data-mp="9xcg4xc8txdh" />
      <Navbar data-id="element-202" data-mp="1y7swa5x37q37" />
      <main className="flex-grow pt-24" data-id="element-203" data-mp="1y79fwtn359ra">
        <article data-id="element-204" data-mp="1y682wjmied6x">
          <header className="bg-pac-navy text-white" data-id="element-205" data-mp="1ai8f9skhv2wk">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-12 md:pt-20 md:pb-16" data-id="element-206" data-mp="1agnkc1u9phy6">
              <Link to="/news" className="inline-flex items-center gap-2 text-pac-gold font-bold hover:text-white transition-colors mb-8 focus:outline-none focus:ring-2 focus:ring-pac-gold rounded" data-id="element-207" data-mp="16gmu7jxt3iba">
                <ArrowLeft className="h-4 w-4" data-id="element-208" data-mp="3fawot2ei7l6b" />
                Back to News
              </Link>
              <p className="text-pac-gold font-bold uppercase tracking-[0.18em] text-sm mb-4" data-id="element-209" data-mp="3kb2kqurt3tu7">
                {article.category} <span className="text-slate-400 mx-1" data-id="element-210" data-mp="2mnkfvv19nbvh">·</span> {article.date}
              </p>
              <h1 className="font-serif text-4xl md:text-6xl font-bold leading-tight max-w-4xl" data-id="element-211" data-mp="2rl2d4o5x82nn">
                {article.title}
              </h1>
            </div>
          </header>

          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212" data-mp="31jryws0xu796">
            <img src={article.image} alt="" className="w-full h-64 md:h-[480px] object-cover rounded-b-xl shadow-lg" data-id="element-213" data-mp="31hyp53v136wy" />

            <div className="max-w-3xl mx-auto py-14 md:py-20" data-id="element-214" data-mp="gs9aaqubrl49">
              <p className="text-xl md:text-2xl leading-relaxed text-pac-navy font-serif mb-10" data-id="element-215" data-mp="21cczbwilzrcw">
                {article.excerpt}
              </p>
              <div className="space-y-7 text-lg leading-relaxed text-slate-700" data-id="element-216" data-mp="1wdjwqz4v1kri">
                {article.content.map(paragraph => <p key={paragraph} data-id="element-217" data-mp="1mn8gqe7wjl49">{paragraph}</p>)}
              </div>

              <div className="mt-14 p-8 bg-pac-sand border-l-4 border-pac-gold" data-id="element-218" data-mp="1hnvxs4k5iy6y">
                <p className="text-pac-navy font-serif text-2xl font-bold mb-3" data-id="element-219" data-mp="1hlrlozc3msvl">
                  Help strengthen Arizona&apos;s local voice.
                </p>
                <p className="text-slate-700 mb-6" data-id="element-220" data-mp="18nz1bgrisv1c">
                  Your support helps AZ City PAC advance practical policies for strong cities, safe neighborhoods, and resilient communities.
                </p>
                <a href="/#donate" className="inline-flex items-center gap-2 bg-pac-red hover:bg-red-800 text-white px-6 py-3 rounded font-bold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2" data-id="element-221" data-mp="330oyc7d6qkcy">
                  Contribute Now <ArrowRight className="h-4 w-4" data-id="element-222" data-mp="1znykp53skkf0" />
                </a>
              </div>

              <Link to="/news" className="inline-flex items-center gap-2 text-pac-blue font-bold hover:text-pac-navy transition-colors mt-12 focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 rounded" data-id="element-223" data-mp="1lsw9c2g6e2ut">
                <ArrowLeft className="h-4 w-4" data-id="element-224" data-mp="1gt05c37habf9" />
                See all updates
              </Link>
            </div>
          </div>
        </article>
      </main>
      <Footer data-id="element-225" data-mp="17ylss8ec1ezu" />
    </div>;
}